import React from 'react'
import throttle from 'lodash/throttle'

import { connect } from 'react-redux'

import BasePureComponent from 'utils/BasePureComponent'
import Table from 'scenes/Claims/components/Table'
import FilterDropDown from 'scenes/Claims/components/FilterDropDown'
import SearchInput from 'components/SearchInput'
import Select from 'components/Select'

import request from 'utils/request'

import {
  WORKSHOPS_URL,
  INSCURANCE_COMPANIES_URL,
  INSCURANCE_BROKERS_URL,
  CLAIM_TYPES,
  STATES_URL,
  CITIES_URL,
  CLIENT_TYPES_URL
} from 'constants'

import {
  fetchInitialData,
  filterChanged,
  searchChanged,
  fetchNextPage,
  statusChanged,
  removeAllFilters
} from 'scenes/Claims/actions'

import './style.scss'

const ORDERING_OPTIONS = [
  { value: '-activation_date', label: 'Fecha de activación cercana' },
  { value: 'activation_date', label: 'Fecha de activación lejana' },
  { value: '-last_update', label: 'Última notificación cercana' },
  { value: 'last_update', label: 'Última notificación lejana' },
  { value: '-updates_count', label: 'Número de notificaciones mayor' },
  { value: 'updates_count', label: 'Número de notificaciones menor' }
]

/*
 * Avoid code duplication. Instead of writing 5 funcs with `request`
 * just define one an call it with different params
 * url (string): dataset endpoint to fetch from
 * results (string): key on the response body object to get dataset-array from.
 * RELATED WITH: _fetchDatasets, _fetchDataset
*/
const DATASETS = [
  {
    url: CLAIM_TYPES,
    results: 'types'
  },
  {
    url: WORKSHOPS_URL,
    results: 'workshops'
  },
  {
    url: INSCURANCE_COMPANIES_URL,
    results: 'companies'
  },
  {
    url: INSCURANCE_BROKERS_URL,
    results: 'brokers'
  },
  {
    url: STATES_URL,
    results: 'states'
  },
  {
    url: CLIENT_TYPES_URL,
    results: 'client_types'
  },
]

class Claims extends BasePureComponent {
  constructor(props) {
    super(props)

    this.state = {
      types: [],
      workshops: [],
      companies: [],
      brokers: [],
      states: [],
      cities: [],
      client_types: [],
      filter_data: {
        'ct': {'order': 1, 'name': 'client_types'},
        't': {'order': 2, 'name': 'types'},
        'ws': {'order': 3, 'name': 'workshops'},
        'ic': {'order': 4, 'name': 'companies'},
        'ib': {'order': 5, 'name': 'brokers'},
        's': {'order': 6, 'name': 'states'},
        'c': {'order': 7, 'name': 'cities'}
      }
    }

    this._bind('_fetchDatasets', '_fetchDataset', '_onScroll',
               '_buildDataSets', '_onFilterUpdate',
               'renderFilterButtons', '_removeFilter', '_deleteFilterButton',
               '_updateClaimStatus', '_removeAllFilters', '_clickCloseIcon')
  }

  componentDidMount() {
    this.props.init()
    this._fetchDatasets()
    window.onscroll = throttle(this._onScroll, 75)
  }

  _buildDataSets() {
    var ds = {
      types: this.state.types,
      workshops: this.state.workshops,
      companies: this.state.companies,
      brokers: this.state.brokers,
      states: this.state.states,
      cities: this.state.cities,
      client_types: this.state.client_types
    }
    return ds
  }

  componentWillReceiveProps(nextProps) {
    // API use 's' as 'state'
    const newSelectedState = nextProps.filters.get('s')
    if (this.props.filters.get('s') !== newSelectedState) {
      if (!!newSelectedState){
        this._fetchDataset({
          url: CITIES_URL(newSelectedState),
          results: 'cities'
        })
      } else {
        this.setState({ cities: [] })
      }
    }
  }

  async _fetchDataset({url, results}) {
    request(url)
    .then((response) => {
      const data = response[results]
      const options = data.map(({id: value, name: label}) => ({ value, label}))
      this.setState({
        [results]: options
      })
    })
    .catch(console.log)
  }

  _fetchDatasets() {
    DATASETS.forEach(this._fetchDataset)
  }

  componentWillUnmount() {
    window.onscroll = null
  }

  _onScroll(e) {
    const documentElement = this.wrapper
    const scrollPosition = window.pageYOffset || documentElement.scrollTop
    const documentHeight = documentElement.scrollHeight
    const diffToFetch = documentHeight * 0.5
    if (documentHeight - scrollPosition < diffToFetch){
      // fetch next results
      if (!this.props.isFetching && this.props.pagination.get('next')) {
        this.props.fetchNextPage()
      }
    }
  }

  _removeFilter(e) {
    let value = e.target.value
    if (value){
      this._deleteFilterButton(value)
    }
  }

  _deleteFilterButton(filter_type) {
    this.props.onFilterChange(filter_type, null)
  }

  _removeAllFilters(){
    this.props.onRemoveAllFilters()
  }

  _updateClaimStatus(status){
    var option = {'value': status, 'label': status}
    this.props.onStatusChange(status)
    this.props.onFilterChange('status', option)
  }


  _onFilterUpdate(filter_type, option) {
    if (option) {      
      this.props.onFilterChange(filter_type, option)
    }else{
      this._deleteFilterButton(filter_type)
    }
  }

  _clickCloseIcon(e){
    let value = e.target.getAttribute('value')
    this._deleteFilterButton(value)
  }

  _getCurrentFilters(){
    const filter_data = this.state.filter_data
    const filters = this.props.filters.toJS()
    delete filters['status'];
    delete filters['ordering'];
    delete filters['q'];
    const old_vals = Object.entries(filters)

    var vals = []
    for (var i=0; i<old_vals.length; i++) {
      var short_name = old_vals[i][0]
      var value = old_vals[i][1]
      var label = ''
      if (value) {
        var filter_name = filter_data[short_name]['name']
        var filter_order = filter_data[short_name]['order']
        var data_set = this.state[filter_name]
        for (var j = 0; j<data_set.length; j++){
          if (data_set[j].value === value) {
              label = data_set[j].label
              break;
          }
        }
        if (label) {
          vals.push([short_name, label, filter_order])  
        }
      }
    }
    const final_filters = vals.sort((a, b) => {
      if (a[2] > b[2]) return 1;
      if (a[2] < b[2]) return -1;
      return 0;
    });
    return final_filters
  }

  renderFilterButtons(){
    const filters = this._getCurrentFilters()
    var buttons = filters.map((filt, index) => (
      <button 
          className="FilterButton"
          type="button"
          key={ index }
          onClick={this._removeFilter}
          value={filt[0]}>
        {filt[1]}
        <i className="material-icons close-icon" value={filt[0]} onClick={this._clickCloseIcon}>close</i>
      </button>
    ))

    if (buttons.length > 1) {
      buttons.push(
        <button className="FilterButton clear-filters" type="button" key={ buttons.length + 100 } onClick={this._removeAllFilters}>Borrar filtros</button>
      )
    }
    return (buttons.length > 0) ? (
      <div className="FilterButtonsContainer">
        {buttons}
      </div>
    ) : null
  }

  render() {
    const filters = this.props.filters.toJS()
    return (
      <section id="Claims" className="Claims">
        <h1 className="Claims__scene_title">Gestión de Siniestros</h1>
        <hr />
        <div className="Claims__head">
          <div className="Claims__head__search">
            <SearchInput
              label="Buscar siniestro"
              onChange={this.props.onSearchChange}
              placeholder="Número póliza, número de siniestro, nombre del cliente, correo del cliente, RFC del cliente o placas del vehículo"
              value={filters.q}
              {...this.props.buttonProps}
            />
          </div>
          <div className="Claims__head__float_filters">
            <FilterDropDown
              dataSets={this._buildDataSets()}
              _filterUpdate={this._onFilterUpdate.bind(this)}
              filters={this.props.filters}/>
          </div>
        </div>
        {this.renderFilterButtons()}
        <div className="Claims__wrapper">
          <div className="Claims__results">
            <div className="Claims__filter_wrapper">
              <div className="Claims__filter_wrapper__state_filter">
                <strong>Estado:</strong>
                <div className="Claims__filter_wrapper__state_filter__buttons">
                  <input  type="radio"
                          name="claimStatus"
                          value="Curso"
                          checked={this.props.status === 'Course'}
                          onChange={() => this._updateClaimStatus('Course') }  />En curso<br/>
                  <input  type="radio"
                          name="claimStatus"
                          value="Historicos"
                          checked={this.props.status === 'Historic'}
                          onChange={() => this._updateClaimStatus('Historic') } />Históricos<br/>
                </div>
              </div>
              <div className="Claims__filter_wrapper__ordering">
                <strong>Ordenar por:</strong>
                <Select
                  onChange={this.props.onOrderingChange}
                  options={ORDERING_OPTIONS}
                  searchable={false}
                  value={filters.ordering}
                  {...this.props.buttonProps}
                />
              </div>
            </div>
            <div className="Claims__table-wrapper" ref={(div) => this.wrapper = div}>
              <Table status={this.props.status} claims={this.props.claims.toJS()} />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    claims: state.claims.get('claims'),
    filters: state.claims.get('filters'),
    buttonProps: {
      disabled: state.claims.get('isFetching')
    },
    pagination: state.claims.get('pagination'),
    isFetching: state.claims.get('isFetching'),
    status: state.claims.get('status')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSearchChange: (evt) => dispatch(searchChanged(evt.target.value)),
    fetchNextPage: () => dispatch(fetchNextPage()),
    init: () => dispatch(fetchInitialData()),
    onRemoveAllFilters: () => dispatch(removeAllFilters()),
    onFilterChange: (filter, selectedOption) => {
      const value = !!selectedOption ? selectedOption.value : null
      dispatch(filterChanged(filter, value))
    },
    onStatusChange: (selectedOption) => dispatch(statusChanged(selectedOption)),
    onOrderingChange: (selectedOption) => {
      const value = !!selectedOption ? selectedOption.value : null
      dispatch(filterChanged('ordering', value))
    },
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Claims)



// WEBPACK FOOTER //
// ./src/scenes/Claims/index.js